export default "__VITE_ASSET__sZVDr1Sk__"